export enum PaddingStyle {
  STANDARD = "standard",
  SOFT = "soft",
  EGGBOX = "eggbox",
  SLOTTED = "slotted",
}
